var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useCallback, useEffect, useMemo } from 'react';
import { CreateBase, ExpandRowButton, useNotify, useRefresh, useResourceContext, } from 'react-admin';
import { useMatch } from 'react-router-dom';
import { Checkbox, TableCell, TableRow } from '@mui/material';
import { RowContext } from './RowContext';
import { focusFirstInput } from './focusFirstInput';
var EditableDatagridCreateForm = function (props) {
    var expand = props.expand, hasBulkActions = props.hasBulkActions, createForm = props.createForm, hasStandaloneCreateForm = props.hasStandaloneCreateForm, isStandaloneCreateFormVisible = props.isStandaloneCreateFormVisible, closeStandaloneCreateForm = props.closeStandaloneCreateForm, _a = props.mutationOptions, mutationOptions = _a === void 0 ? {} : _a, transform = props.transform, disableAutofocus = props.disableAutofocus;
    var resource = useResourceContext(props);
    var match = useMatch("/".concat(resource, "/create/*"));
    if (hasStandaloneCreateForm) {
        // create form triggered by state
        return isStandaloneCreateFormVisible ? (_jsx(DefaultCreateForm, { expand: expand, hasBulkActions: hasBulkActions, createForm: createForm, closeStandaloneCreateForm: closeStandaloneCreateForm, mutationOptions: mutationOptions, transform: transform, resource: resource, disableAutofocus: disableAutofocus })) : null;
    }
    else {
        // create form in a route
        return !!match ? (_jsx(DefaultCreateForm, { expand: expand, hasBulkActions: hasBulkActions, createForm: createForm, closeStandaloneCreateForm: closeStandaloneCreateForm, mutationOptions: mutationOptions, transform: transform, resource: resource, disableAutofocus: disableAutofocus })) : null;
    }
};
var DefaultCreateForm = function (_a) {
    var expand = _a.expand, hasBulkActions = _a.hasBulkActions, createForm = _a.createForm, closeStandaloneCreateForm = _a.closeStandaloneCreateForm, _b = _a.mutationOptions, mutationOptions = _b === void 0 ? {} : _b, transform = _a.transform, resource = _a.resource, disableAutofocus = _a.disableAutofocus;
    var notify = useNotify();
    var refresh = useRefresh();
    var defaultOnSuccess = useCallback(function () {
        notify('ra.notification.created', {
            type: 'info',
            messageArgs: { smart_count: 1 },
        });
        refresh();
        closeStandaloneCreateForm();
    }, [closeStandaloneCreateForm, notify, refresh]);
    var defaultOnError = useCallback(function (error) {
        notify(typeof error === 'string'
            ? error
            : error.message || 'ra.notification.http_error', { type: 'warning' });
    }, [notify]);
    var createContext = useMemo(function () { return ({
        open: function () {
            /* */
        },
        close: closeStandaloneCreateForm,
    }); }, [closeStandaloneCreateForm]);
    useEffect(function () {
        if (disableAutofocus)
            return;
        var observer = focusFirstInput(document.body, '#new_record');
        return function () {
            observer.disconnect();
        };
    }, [disableAutofocus]);
    return (_jsx(RowContext.Provider, { value: createContext, children: _jsx(CreateBase, { mutationOptions: __assign({ onSuccess: defaultOnSuccess, onError: defaultOnError }, mutationOptions), transform: transform, resource: resource, children: _jsxs(TableRow, { id: "new_record", children: [expand && (_jsx(TableCell, { padding: "none", children: _jsx(ExpandRowButton, { expanded: false, disabled: true }) })), hasBulkActions && (_jsx(TableCell, { padding: "checkbox", children: _jsx(Checkbox, { color: "primary", disabled: true }) })), createForm] }, "create-record") }) }));
};
export default EditableDatagridCreateForm;
